export interface AdminEnvironment {
  id: string;
  env_code: string;
  region_code: string;
  region_name: string;
  stage: "pre" | "prod" | string;
  display_name: string;
  admin_base_url?: string;
  is_prod: boolean;
  is_active: boolean;
  status: string;
  sort_order?: number;
}

const ENV_OPTIONS_KEY = "quantum_env_options";
const CURRENT_ENV_KEY = "quantum_current_env";

function parseJson<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function getStoredEnvOptions(): AdminEnvironment[] {
  return parseJson<AdminEnvironment[]>(localStorage.getItem(ENV_OPTIONS_KEY)) ?? [];
}

export function getStoredCurrentEnvironment(): AdminEnvironment | null {
  return parseJson<AdminEnvironment>(localStorage.getItem(CURRENT_ENV_KEY));
}

export function setStoredEnvironmentState(
  envOptions: AdminEnvironment[] = [],
  currentEnv: AdminEnvironment | null = null
) {
  localStorage.setItem(ENV_OPTIONS_KEY, JSON.stringify(envOptions));
  if (currentEnv) {
    localStorage.setItem(CURRENT_ENV_KEY, JSON.stringify(currentEnv));
  } else if (envOptions.length > 0) {
    localStorage.setItem(CURRENT_ENV_KEY, JSON.stringify(envOptions[0]));
  } else {
    localStorage.removeItem(CURRENT_ENV_KEY);
  }
}

export function setStoredCurrentEnvironment(env: AdminEnvironment | null) {
  if (env) {
    localStorage.setItem(CURRENT_ENV_KEY, JSON.stringify(env));
  } else {
    localStorage.removeItem(CURRENT_ENV_KEY);
  }
}

export function clearStoredEnvironmentState() {
  localStorage.removeItem(ENV_OPTIONS_KEY);
  localStorage.removeItem(CURRENT_ENV_KEY);
}
